import apiClient from "@/api/apiClient";
import { AxiosRequestConfig, AxiosResponse } from "axios";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const orvalAxiosAdapter = async <T = any>(
  config: AxiosRequestConfig
): Promise<T> => {
  const response: AxiosResponse<T> = await apiClient.request(config);
  return response.data;
};
